import { TipTapRenderer, type TipTapDoc } from '@/components/richtext/TipTapRenderer';

/**
 * Thin compliance-flavored wrapper around the shared TipTap renderer.
 * The render logic moved to `components/richtext/TipTapRenderer` when the
 * training LMS landed (lessons share the document shape); this wrapper
 * exists so the compliance pages keep importing `SopRenderer` unchanged —
 * zero behavior change, SOP-specific empty copy included.
 */

export type { TipTapDoc, TipTapNode } from '@/components/richtext/TipTapRenderer';

export function SopRenderer({ doc }: { doc: TipTapDoc | null | undefined }) {
  return <TipTapRenderer doc={doc} emptyText="This SOP has no content yet." />;
}
